export const API_BASE_URL = import.meta.env.VITE_DMS_API;

export const API_ENDPOINTS = {
    ROLES: {
        LIST: '/dms-v2-srv/user-srv/role/utils/list',
        CREATE: '/dms-v2-srv/user-srv/role',
        UPDATE: (id: string) => `/dms-v2-srv/user-srv/role/${id}`,
        DELETE: (id: string) => `/dms-v2-srv/user-srv/role/${id}`,
        ROLE_REPORT: `/dms-v2-srv/user-srv/role/role-stats`,
        DROPDOWN: '/dms-v2-srv/user-srv/role/utils/dropdown',

    },
    PERMISSIONS: {
        LIST: '/dms-v2-srv/user-srv/permissions/list',
        DROPDOWN: '/dms-v2-srv/user-srv/permissions/utils/dropdown',
        ROLE_GET: (role_key: string) => `/dms-v2-srv/user-srv/permissions/role/${role_key}`,
        ROLE_ASSIGN: '/dms-v2-srv/user-srv/permissions/role/assign',
    },
    GROUPS: {
        LIST: '/dms-v2-srv/user-srv/group/utils/list',
        CREATE: '/dms-v2-srv/user-srv/group',
        UPDATE: (id: string) => `/dms-v2-srv/user-srv/group/${id}`,
        DELETE: (id: string) => `/dms-v2-srv/user-srv/group/${id}`,
        GET_BY_ID: (id: string) => `/dms-v2-srv/user-srv/group/utils/get/${id}`,
        GROUP_REPORT: `/dms-v2-srv/user-srv/group/group-stats`,
        GROUP_DROPDOWN: 'dms-v2-srv/user-srv/group/drop-down-list',
        GROUP_ROLE_MAPPING: '/dms-v2-srv/user-srv/group-role-permission-map',
    },
    SETTINGS: {
        GET: '/dms-v2-srv/settings-srv',
        SAVE: '/dms-v2-srv/settings-srv',
        ONEDRIVE_REDIRECT_URIS: '/dms-v2-srv/settings-srv/onedrive/redirect-uris',
        ONEDRIVE_REGISTER_REDIRECT_URI: '/dms-v2-srv/settings-srv/onedrive/register-redirect-uri',
        ONEDRIVE_UPDATE_REDIRECT_URI: '/dms-v2-srv/settings-srv/onedrive/redirect-uri',
        ONEDRIVE_DELETE_REDIRECT_URI: '/dms-v2-srv/settings-srv/onedrive/redirect-uri',
    },
    TENANTS: {
        LIST: '/dms-v2-srv/tenants-srv/list',
        METRICS: '/dms-v2-srv/tenants-srv/metrics',
        CHECK_KEY: (key: string) => `/dms-v2-srv/tenants-srv/check/key/${key}`,
        CHECK_NAME: (name: string) => `/dms-v2-srv/tenants-srv/check/name/${name}`,
        CREATE: '/dms-v2-srv/tenants-srv/create',
        GET_BY_KEY: (key: string) => `/dms-v2-srv/tenants-srv/${key}`,
        UPDATE: (key: string) => `/dms-v2-srv/tenants-srv/${key}`,
        UPDATE_STATUS: (key: string) => `/dms-v2-srv/tenants-srv/status/${key}`,
        DELETE: (key: string) => `/dms-v2-srv/tenants-srv/${key}`,
        INGRESS_YAML: '/dms-v2-srv/tenants-srv/ingress/yaml',
        INGRESS_HISTORY: (key: string) => `/dms-v2-srv/tenants-srv/ingress/history/${key}`,
        DNS_ALL: '/dms-v2-srv/tenants-srv/dns/all',
        DNS_BY_TENANT: (key: string) => `/dms-v2-srv/tenants-srv/dns/${key}`,
        DNS_CREATE: '/dms-v2-srv/tenants-srv/dns/record',
        DNS_UPDATE: (id: string) => `/dms-v2-srv/tenants-srv/dns/record/${id}`,
        DNS_DELETE: (id: string) => `/dms-v2-srv/tenants-srv/dns/record/${id}`,
    },
    USERS: {
        LIST: '/dms-v2-srv/user-srv/utils/list',
        CREATE: '/dms-v2-srv/user-srv/register',
        UPDATE: (id: string) => `/dms-v2-srv/user-srv/update/${id}`,
        DELETE: '/dms-v2-srv/user-srv',
        GET_BY_ID: `/dms-v2-srv/user-srv`,
        TOTAL_COUNTS: '/dms-v2-srv/user-srv/total-counts',
        MAPPED_ROLES: '/dms-v2-srv/user-srv/group/roles',
        INVITE_USER: '/dms-v2-srv/user-srv/users/invite/utils/list',
        USER_REINVITE: '/dms-v2-srv/user-srv/users/invite/reinitate',
        USER_REVOKE: '/dms-v2-srv/user-srv/users/invite/revoke',
        INVITE: '/dms-v2-srv/user-srv/users/invite/initate',
        USER_GROUP_MAPPING: '/dms-v2-srv/user-srv/user-group-map',
        USER_PROFILE_UPDATE: '/dms-v2-srv/user-srv/update',
        USER_BULK_UPLOAD: '/dms-v2-srv/user-srv/bulk-import-members',
    },
    DOCUMENT_STORES: {
        LIST: '/dms-v2-srv/document-store-srv/utils/list',
        CREATE: '/dms-v2-srv/document-store-srv',
        UPDATE: (id: string) => `/dms-v2-srv/document-store-srv/${id}`,
        DELETE: (id: string) => `/dms-v2-srv/document-store-srv/${id}`,
        GET_BY_ID: (id: string) => `/dms-v2-srv/document-store-srv/${id}`,
        UPLOAD_FILE: (documentStoreId: string, aiPerformanceLevel: string, uploadType: string, fileProcessingType: string) =>
            `/dms-v2-srv/storage-srv/utils/upload-with-process/${documentStoreId}?ai_performance_level=${aiPerformanceLevel}&upload_type=${uploadType}&file_processing_type=${fileProcessingType}`,
        DROPDOWN: '/dms-v2-srv/document-store-srv/dropdown/list'
    },
    UPLOADED_FILES: {
        GET_STATUS_BY_IDS: '/dms-v2-srv/uploaded-file-srv/utils/get-status-by-ids',
        LIST: '/dms-v2-srv/uploaded-file-srv/utils/list',
        DELETE: (id: string) => `/dms-v2-srv/uploaded-file-srv/${id}`
    },
    FOLDERS: {
        CREATE: '/dms-v2-srv/document-store-srv/folder',
        GET_BY_ID: (id: string) => `/dms-v2-srv/document-store-srv/folder/${id}`,
        LIST_CHILDREN: '/dms-v2-srv/document-store-srv/folder/utils/list',
        LIST_ALL: '/dms-v2-srv/document-store-srv/folder/utils/list-all',
        UPDATE: (id: string) => `/dms-v2-srv/document-store-srv/folder/${id}`,
        MOVE: (id: string) => `/dms-v2-srv/document-store-srv/folder/${id}/move`,
        DELETE: (id: string) => `/dms-v2-srv/document-store-srv/folder/${id}`,
    },
    WEBHOOKS: {
        LIST: '/dms-v2-srv/webhook-config-srv/utils/list',
        CREATE: '/dms-v2-srv/webhook-config-srv',
        UPDATE: (id: string) => `/dms-v2-srv/webhook-config-srv/${id}`,
        DELETE: (id: string) => `/dms-v2-srv/webhook-config-srv/${id}`,
        GET_BY_ID: (id: string) => `/dms-v2-srv/webhook-config-srv/${id}`
    },
    API_ENDPOINTS: {
        LIST: '/dms-v2-srv/api-config-srv/utils/list',
        CREATE: '/dms-v2-srv/api-config-srv',
        UPDATE: `/dms-v2-srv/api-config-srv`,
        DELETE: (id: string) => `/dms-v2-srv/api-config-srv/${id}`,
        GET_BY_ID: (id: string) => `/dms-v2-srv/api-config-srv/${id}`,
        STATS: '/dms-v2-srv/api-config-srv/api-config-stats'
    },
    TEMPLATES: {
        LIST: '/dms-v2-srv/schema-config-srv/utils/list',
        CREATE: '/dms-v2-srv/schema-config-srv',
        UPDATE: (id: string) => `/dms-v2-srv/schema-config-srv/${id}`,
        DELETE: (id: string) => `/dms-v2-srv/schema-config-srv/${id}`,
        GET_BY_ID: (id: string) => `/dms-v2-srv/schema-config-srv/${id}`,
        DROPDOWN: '/dms-v2-srv/schema-config-srv/dropdown/list'
    },
    GOOGLE_DRIVE: {
        AUTH: '/dms-v2-srv/google-drive-file-storage-srv/auth/google',
        LIST_FILES: '/dms-v2-srv/google-drive-file-storage-srv/list/files',
        UPLOAD_FOLDER: '/dms-v2-srv/google-drive-file-storage-srv/utils/upload-folder-with-process'
    },
    DROPBOX: {
        AUTH: '/dms-v2-srv/dropbox-file-storage-srv/auth',
        LIST_FILES: '/dms-v2-srv/dropbox-file-storage-srv/list',
        UPLOAD_FOLDER: '/dms-v2-srv/dropbox-file-storage-srv/utils/upload-folder-with-process'
    },
    ONEDRIVE: {
        AUTH: '/dms-v2-srv/one-drive-file-storage-srv/one-drive-login',
        LIST_FILES: '/dms-v2-srv/one-drive-file-storage-srv/one-drive-files/list',
        UPLOAD_FOLDER: '/dms-v2-srv/one-drive-file-storage-srv/utils/upload-one-drive-folder-with-process'
    },
    DOCUMENT_PARSE_DATA: {
        LIST: '/dms-v2-srv/document-parse-data-srv/utils/list',
        GET_STATUS_BY_IDS: '/dms-v2-srv/document-parse-data-srv/utils/get-status-by-ids'
    },
    DOCUMENT_PARSING: {
        PROCESS_FILES: (documentStoreId: string) => `/dms-v2-srv/document-parsing-srv/process-files?document_store_id=${documentStoreId}`
    },
    EXTERNAL_SOURCE: {
        API_INTEGRATION_GET_CONFIG: "/dms-v2-srv/api-file-storage-srv/list/files",
        API_INTEGRATION_UPLOAD_FOLDER: "/dms-v2-srv/api-file-storage-srv/upload",
        DATABASE_GET_CONFIG: "/dms-v2-srv/database-file-storage-srv/list/files",
        DATABASE_UPLOAD_FOLDER: "/dms-v2-srv/database-file-storage-srv/upload",
    },
    SPREADSHEET_CONNECTOR: {
        AUTH_GOOGLE: '/dms-v2-srv/spreadsheet-connector-srv/auth/google',
        LIST_CREDENTIALS: '/dms-v2-srv/spreadsheet-connector-srv/credentials/list',
        LIST_SHEETS: (credentialId: string) => `/dms-v2-srv/spreadsheet-connector-srv/credentials/${credentialId}/sheets`,
        CREATE: '/dms-v2-srv/spreadsheet-connector-srv',
        GET_BY_ID: (id: string) => `/dms-v2-srv/spreadsheet-connector-srv/${id}`,
        ACTIVE_SHEETS: '/dms-v2-srv/spreadsheet-connector-srv/utils/sheets',
        LIST_ALL: '/dms-v2-srv/spreadsheet-connector-srv/utils/list',
        UPDATE: (id: string) => `/dms-v2-srv/spreadsheet-connector-srv/${id}`,
        PAUSE: (id: string) => `/dms-v2-srv/spreadsheet-connector-srv/${id}/pause`,
        RESUME: (id: string) => `/dms-v2-srv/spreadsheet-connector-srv/${id}/resume`,
        DELETE: (id: string) => `/dms-v2-srv/spreadsheet-connector-srv/${id}`,
        SYNC_HISTORY: '/dms-v2-srv/spreadsheet-connector-srv/utils/sync-history',
    },
    FOLDER_CONNECTION: {
        CONNECT: "/dms-v2-srv/folder-connection-srv/connect",
        LIST: "/dms-v2-srv/folder-connection-srv/list",
        SYNC: (id: string) => `/dms-v2-srv/folder-connection-srv/${id}/sync`,
        DELETE: (id: string) => `/dms-v2-srv/folder-connection-srv/${id}`,
        LOGS: (id: string) => `/dms-v2-srv/folder-connection-srv/${id}/logs`,
        AUTO_SYNC: (id: string) => `/dms-v2-srv/folder-connection-srv/${id}/auto-sync`,
        ACTIVE: (id: string) => `/dms-v2-srv/folder-connection-srv/${id}/active`,
    },
    POSTGRES: {
        TEST_CONNECTION: '/dms-v2-srv/postgres-node-srv/test-connection',
        SCHEMAS: '/dms-v2-srv/postgres-node-srv/schemas',
        TABLES: '/dms-v2-srv/postgres-node-srv/tables',
        COLUMNS: '/dms-v2-srv/postgres-node-srv/columns',
        ADD_COLUMN: '/dms-v2-srv/postgres-node-srv/add-column',
    },
    WEB_SCRAPER: {
        LIST: '/dms-v2-srv/web-scraper-srv/utils/list',
        CREATE: '/dms-v2-srv/web-scraper-srv',
        GET_BY_ID: (id: string) => `/dms-v2-srv/web-scraper-srv/${id}`,
        START: (id: string) => `/dms-v2-srv/web-scraper-srv/${id}/start`,
        PAUSE: (id: string) => `/dms-v2-srv/web-scraper-srv/${id}/pause`,
        RESUME: (id: string) => `/dms-v2-srv/web-scraper-srv/${id}/resume`,
        CANCEL: (id: string) => `/dms-v2-srv/web-scraper-srv/${id}/cancel`,
        DELETE: (id: string) => `/dms-v2-srv/web-scraper-srv/${id}`,
        ITEMS_LIST: (id: string) => `/dms-v2-srv/web-scraper-srv/${id}/items/list`,
        ITEMS_SKIP: (id: string) => `/dms-v2-srv/web-scraper-srv/${id}/items/skip`,
        ITEMS_UNDO_SKIP: (id: string) => `/dms-v2-srv/web-scraper-srv/${id}/items/undo-skip`,
        IMPORT: (id: string) => `/dms-v2-srv/web-scraper-srv/${id}/import`,
        SKIPPED_LIST: (id: string) => `/dms-v2-srv/web-scraper-srv/${id}/skipped/list`,
        PREVIEW: '/dms-v2-srv/web-scraper-srv/preview',
    },
    DASHBOARD: {
        METRICS: '/dms-v2-srv/report/documen-store-report',
        PROCESSING_VOLUME: '/dms-v2-srv/report/documen-processing-volume',
        WORKFLOW_STATUS: '/dms-v2-srv/report/list-workflow-status',
        WORKFLOW_EXECUTION: '/dms-v2-srv/report/workflow-status',
        WORKFLOW_TEMPLATE_STATUS: '/dms-v2-srv/report/workflow-template-status'
    },
    REPORTS: {
        DOCUMENT_PROCESS_REPORT: "/dms-v2-srv/report/list-uploaded-files",
    },
    GLOBAL_SEARCH: {
        // Single backend endpoint that joins five collections (folders,
        // files, workflows, users, notifications) into one grouped result.
        SEARCH: "/dms-v2-srv/global-search-srv",
    },
    NOTIFICATION: {
        // Tenant-wide list — every notification in the tenant. Matches the
        // legacy behaviour where users saw the full pool, not just their own.
        // The per-user endpoint is exposed separately as LIST_MINE for the
        // bell badge / future personal-only views.
        LIST: "/dms-v2-srv/notification-srv/all",
        LIST_MINE: "/dms-v2-srv/notification-srv",
        MARK_AS_READ: "/dms-v2-srv/notification-srv/mark-as-read",
        MARK_ALL_AS_READ: "/dms-v2-srv/notification-srv/mark-all-as-read",
        DELETE: "/dms-v2-srv/notification-srv/delete",
        // Per-user notification preferences (master switch · channel
        // defaults · quiet hours · per-event overrides).
        PREFERENCES: "/dms-v2-srv/notification-srv/preferences",
        // Server-Sent Events stream for live bell badge updates.
        STREAM: "/dms-v2-srv/notification-srv/stream",
        // Push subscriptions — register / list / disable per device.
        PUSH_SUBSCRIBE: "/dms-v2-srv/notification-srv/push/subscribe",
        PUSH_SUBSCRIBERS: "/dms-v2-srv/notification-srv/push/subscribers",
        PUSH_UNSUBSCRIBE: (id: string) =>
            `/dms-v2-srv/notification-srv/push/subscribe/${id}`,
    },
    WORKFLOW: {
        RUN: '/dms-v2-srv/workflow-config-srv',
        WORKFLOW_LIST: '/dms-v2-srv/workflow-template-srv/workflow-template/utils/list',
        WORKFLOW_CRUD: "/dms-v2-srv/workflow-template-srv/workflow-template",
        EXECUTION: '/dms-v2-srv/workflow-config-srv',
        EXECUTION_GET_BY_ID: (id: string) => `/dms-v2-srv/workflow-execution-header/${id}`,
        EXECUTION_BY_TEMPLATE_ID: (templateId: string) => `/dms-v2-srv/workflow-execution-header/template/${templateId}`,
        EXECUTION_HEADERS: '/dms-v2-srv/workflow-execution-header/utils/list',
        EXECUTION_STATUS_BY_IDS: '/dms-v2-srv/workflow-execution-header/utils/get-status-by-ids',
        TOKEN_ANALYSIS: '/dms-v2-srv/workflow-execution-srv/workflow-execution/utils/token-analysis',
        TOKEN_ANALYSIS_BY_TEMPLATE: '/dms-v2-srv/workflow-execution-header/utils/token-analysis',
    },
    ONEDRIVE_CONNECTOR: {
        LOGIN: '/dms-v2-srv/one-drive-connector-node-srv/login',
        LIST_FOLDERS: '/dms-v2-srv/one-drive-connector-node-srv/one-drive-folder/list',
        LIST_CREDENTIALS: '/dms-v2-srv/one-drive-connector-node-srv/one-drive-folder/dropdown-list',
    },
    OUTLOOK_CONNECTOR: {
        LOGIN: '/dms-v2-srv/workflow-connector-srv/outlook/login',
        LIST_CREDENTIALS: '/dms-v2-srv/workflow-connector-srv/outlook/list-credentials',
        GENERATE_TEMPLATE: '/dms-v2-srv/workflow-connector-srv/outlook/generate-template',
        PREVIEW_STANDARD: '/dms-v2-srv/workflow-connector-srv/outlook/preview-standard',
    },
    GOOGLE_CONNECTOR: {
        LOGIN: '/dms-v2-srv/google-connector-node-srv/auth/google',
        LIST_CREDENTIALS: '/dms-v2-srv/google-connector-node-srv/dropdown/list',
        GENERATE_TEMPLATE: '/dms-v2-srv/google-connector-node-srv/generate-template',
        PREVIEW_STANDARD: '/dms-v2-srv/google-connector-node-srv/preview-standard',
    },
    AUTH: {
        LOGOUT: '/dms-v2-srv/login-srv/logout',
    },
    SESSION: {
        REVOKE_OTHERS: '/dms-v2-srv/login-srv/revoke-others',
        REVOKE_ALL: '/dms-v2-srv/login-srv/revoke-all',
    },
    CAMPAIGNS: {
        LIST: '/dms-v2-srv/campaign-srv/campaign/utils/list',
        CREATE: '/dms-v2-srv/campaign-srv/campaign',
        UPDATE: (id: string) => `/dms-v2-srv/campaign-srv/campaign/${id}`,
        DELETE: (id: string) => `/dms-v2-srv/campaign-srv/campaign/${id}`,
        GET_BY_ID: (id: string) => `/dms-v2-srv/campaign-srv/campaign/${id}`,
        APPROVE: (id: string) => `/dms-v2-srv/campaign-srv/campaign/${id}/approve`,
        SEARCH: '/dms-v2-srv/campaign-srv/retrieval/search',
        GENERATE: '/dms-v2-srv/campaign-srv/retrieval/generate',
        GENERATION: (id: string) => `/dms-v2-srv/campaign-srv/generation/${id}`,
        GENERATION_REGEN: (id: string) => `/dms-v2-srv/campaign-srv/generation/${id}/regenerate-section`,
        GENERATION_INSIGHTS: (id: string) => `/dms-v2-srv/campaign-srv/generation/${id}/insights`,
        GENERATION_EXPORT: (id: string) => `/dms-v2-srv/campaign-srv/generation/${id}/export`,
    }
}